import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <CommentsSection />
        <TopicsSection />
        <FeaturesSection />
        <CardsSection />
        <FAQSection />
        <MediaSection />
        <CarouselSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}